// Run this example by adding <%= javascript_pack_tag 'hello_react' %> to the head of your layout file,
// like app/views/layouts/application.html.erb. All it does is render <div>Hello React</div> at the bottom
// of the page.
window.customerPortal = true
import React, { useEffect } from 'react'
import ReactDOM from 'react-dom'
import enTranslations from '@shopify/polaris/locales/en.json'
import { AppProvider, Page } from '@shopify/polaris'
import * as Sentry from '@sentry/react'
import { Provider } from 'react-redux'
import createStore from 'Redux'
import 'Styles/main.css'
import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'react-toggle/style.css'
// import '@shopify/polaris/build/esm/styles.css'
import 'Config/reactotron'
import { BrowserRouter } from 'react-router-dom'
import CustomerPortalMain from './Containers/CustomerPortalMain'
import Link from './Containers/Link'

const { store } = createStore()
Sentry.init({
  dsn: 'https://11c2600257a14c9f80b6593130f02631@o585271.ingest.sentry.io/5738186',
  integrations: [Sentry.browserTracingIntegration()],
  environment:
    process.env.NODE_ENV === 'development' ? 'development' : 'production',
  // We recommend adjusting this value in production, or using tracesSampler
  // for finer control
  tracesSampleRate: 1.0,
})

const CustomerPortalReact = (props) => {
  Sentry.setContext('shop', props)
  console.log(props)

  // const theme = {
  //   colors: {},
  // }

  // if (props.background_color) {
  //   theme.colors.surface = props.background_color
  // }

  // if (props.button_color) {
  //   theme.colors.primary = props.button_color

  //   document.documentElement.style.setProperty(
  //     '--p-action-primary',
  //     props.button_color
  //   )
  // }

  // if (props.logo) {
  //   theme.logo = {
  //     width: 150,
  //     topBarSource: props.logo,
  //     url: '',
  //   }
  // }

  return (
    <BrowserRouter>
      <AppProvider linkComponent={Link} i18n={enTranslations}>
        <Provider store={store}>
          <CustomerPortalMain {...props} />
        </Provider>
      </AppProvider>
    </BrowserRouter>
  )
}

export default CustomerPortalReact
